import { PaymentCurrencyType } from "@/types/graphql/partner.generated";

export const CURRENCY_SYMBOLS: Record<PaymentCurrencyType, string> = {
  [PaymentCurrencyType.UsdType]: "$",
  [PaymentCurrencyType.EurType]: "€",
  [PaymentCurrencyType.MdlType]: "L",
  [PaymentCurrencyType.GbpType]: "£",
  [PaymentCurrencyType.CadType]: "CA$",
  [PaymentCurrencyType.PlnType]: "zł",
};

/** Символы валют по коду (для amount.currency из API) */
export const CURRENCY_SYMBOLS_BY_CODE: Record<string, string> = {
  RUB: "₽",
  USD: "$",
  EUR: "€",
  MDL: "L",
  GBP: "£",
  CAD: "CA$",
  PLN: "zł",
};
